import { NoteDto } from '@lmt/shared-types';
import React from 'react';
import NoteIcon from '@lmt/unicorn-shared/app/icons/note.svg?react';
import NoteUrgentIcon from '@lmt/unicorn-shared/app/icons/note-urgent.svg?react';
import NoteEditIcon from '@lmt/unicorn-shared/app/icons/note-edit.svg?react';
import styles from './NotesPanel.module.scss';
import { useGlobalForms } from '../../global-forms/useGlobalForms';
import { IconButton } from '../../common/ui-kit/IconButton';
import { getFormattedLongDateRange } from '../../patients/common';
import i18next from 'i18next';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';

interface Props {
  note: NoteDto;
}

function getTitle(note: NoteDto) {
  let title = '';
  if (note.startDate) {
    title = getFormattedLongDateRange(note.startDate, note.endDate);
  }
  if (note.urgent) {
    const prefix = note.startDate ? ' | ' : '';
    title += prefix + i18next.t('translation:dashboard.notes.urgent');
  }
  return title;
}

export const NoteItem: React.FC<Props> = (props) => {
  const { note } = props;
  const forms = useGlobalForms();
  const claims = useClaims();
  const title = getTitle(note);

  return (
    <div className={styles.noteContainer} data-test-id="note">
      <div className={styles.noteInfo}>
        <div
          className={styles.noteSign}
          data-test-id="note-sign"
          data-is-urgent={note.urgent}
        >
          {note.urgent ? (
            <NoteUrgentIcon className={styles.urgentNoteIcon} />
          ) : (
            <NoteIcon className={styles.noteIcon} />
          )}
        </div>
        <div className={styles.noteData}>
          {!!title && (
            <div className={styles.noteTitle} data-test-id="note-title">
              {title}
            </div>
          )}
          <div
            data-first={!title}
            className={styles.noteText}
            data-test-id="note-text"
          >
            {note.text}
          </div>
        </div>
      </div>
      {claims.permissions.manageNotes && (
        <div className={styles.controls}>
          <IconButton
            iconComponent={<NoteEditIcon className={styles.icon} />}
            testId="edit-note"
            onClick={() => forms.openNoteEditing(note.id)}
          />
        </div>
      )}
    </div>
  );
};
